import { getNotifications, addNotifications, updateNotifications, deleteNotifications, clearErrorBack } from '../../../../actions/NotificationActions';
import { CREATE_NOTIFICATION, GET_NOTIFICATIONS, UPDATE_NOTIFICATION, DELETE_NOTIFICATION, GET_ERRORS } from '../../../../actions/types';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import AddNotificationModal from './AddNotificationModal';
import BootstrapTable from 'react-bootstrap-table-next';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingOverlay from 'react-loading-overlay';
import Combobox from 'react-widgets/lib/Combobox';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import docs from '../../../../config/docs';
import { Info } from '@material-ui/icons';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
import { connect } from 'react-redux';
import '../MainContent.scss';
import './Notification.scss';
const URL = docs.docsNotifications;

function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

class Notification extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		activeLoader:         true,
		showSnackBar:         false,
		textSnackBar:         '',
		severitySnackBar:     'success',
		notifications:        [],
		showDeactivateDialog: false,
		selectedId:           0,
		addModalIsVisible:    false,
		skip:                 1,
		modalType:            'NORMAL',
		type:                 'TODAS',
		types:                [ 
			'Unicas',
			'Recurrentes',
			'Todas'
		],
		comboboxSelected:     'Selecciona un tipo de notificación'
	};

	constructor(props) {
		super(props);
		this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
		this.onGetNotifications          = this.onGetNotifications.bind(this);
		this.onDeactivate                = this.onDeactivate.bind(this);
		this.onChangeType                = this.onChangeType.bind(this);
		this.handleUpdate                = this.handleUpdate.bind(this);
		this.handleSubmit                = this.handleSubmit.bind(this);
		this.handleCancel                = this.handleCancel.bind(this);
		this.handleClose                 = this.handleClose.bind(this);
		this.openModal                   = this.openModal.bind(this);
	}

	componentDidMount() {
		this.props.getNotifications(this.state.skip)
	}

	componentDidUpdate(prevProps) {
		if (this.props.notifications !== this.state.notifications) {
			this.setState({
				activeLoader:  false,
				notifications: this.props.notifications,
			});
		}
		else if (this.props.actionType === DELETE_NOTIFICATION && prevProps.actionType !== DELETE_NOTIFICATION) {
			this.props.getNotifications(this.state.skip);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Notificación desactivada exitosamente.',
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === UPDATE_NOTIFICATION && prevProps.actionType !== UPDATE_NOTIFICATION) {
			this.props.getNotifications(this.state.skip);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Notificación actualizada exitosamente.',
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === CREATE_NOTIFICATION && prevProps.actionType !== CREATE_NOTIFICATION) {
			this.props.getNotifications(this.state.skip);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Notificación creada exitosamente.',
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     this.props.error,
				severitySnackBar: 'error',
			});
		}

	}


	///---------------------------------------EVENTS-------------------------------------
	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showSnackBar: false
		})
	};

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showDeactivateDialog: false
		})
	};

	openModal = () => {
		this.setState({
			addModalIsVisible: true,
			modalType: 'NORMAL'
		})
	}

	handleUpdate(id, title, description, image, days, hour, type, startDate, finalDate) {
		this.props.updateNotifications(id, title, description, image, days, hour, type, startDate, finalDate);
		this.setState({
			activeLoader: true,
			notificationData: null,
			addModalIsVisible: false
		});
	}

	handleSubmit(title, description, image, days, hour, type, startDate, finalDate) {

		this.props.addNotifications(
			title, description, image, days, hour, type, startDate, finalDate
		)
		this.setState({
			activeLoader: true,
			notificationData: null,
			addModalIsVisible: false
		})
	}

	handleCancel() {
		this.setState({
			addModalIsVisible: false,
			refacModalIsVisible: false,
			notificationData: null
		})
	}

	onChangeType(newOption) {
		this.setState({
			activeLoader: true,
			skip: 1,
			type: newOption
		})
		switch (newOption) {
			case 'Unicas':
				this.props.getNotifications(this.state.skip, 'U');
				break;

			case 'Recurrentes':
				this.props.getNotifications(this.state.skip, 'R');
				break;

			default:
				this.props.getNotifications(this.state.skip);
				break;
		}
	}

	onPressDelete(id) {
		this.setState({
			showDeactivateDialog: true,
			selectedId: id,
		})
	}

	onDeactivate() {
		this.props.deleteNotifications(this.state.selectedId);
		this.setState({
			activeLoader: true,
			showDeactivateDialog: false,
			notificationData: null
		})
	}
	onGetNotifications() {
		this.setState({
			activeLoader: true,
		})
		this.props.getNotifications(this.state.skip);
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	linkActions = (cell, row, rowIndex, formatExtraData) => {
		return ([
			<Button
				key={row.innerBranchId + 1}
				className='edit-buttonOK'
				onClick={() => {
					this.setState({
						modalType: 'UPDATE',
						notificationData: row,
						addModalIsVisible: !this.state.addModalIsVisible,
						defaultInnerBranchId: row.innerBranchId
					})
				}}
			>
				<span style={{ fontSize: '8px' }}> Editar </span>
			</Button>,
			<Button
				key={row.innerBranchId + 2}
				className='buttonDelete'
				onClick={() => {
					this.onPressDelete(row._id);
				}}
			>
				<span style={{ fontSize: '8px' }}> Eliminar </span>
			</Button>
		]);
	};


	///---------------------------------------VIEW-------------------------------------

	render() {

		const customOptions = {
			noDataText: '<div className="color-red">No hay datos disponibles para su consulta.</div>'
		};

		const columns = [
			{
				dataField: 'title',
				text:      'Titulo',
				headerStyle: () => {
					return { width: '15%' };
				},
				formatter: (cell) => {
					return cell.toUpperCase()
				}
			},
			{
				dataField: 'description',
				text:      'Descripcion',
			},
			{
				dataField: 'type',
				text:      'Tipo de notificación',
				formatter: (cell) => {
					return cell === 'R' ? 'Recurrente' : 'Unica';
				}
			},
			{
				dataField: 'startDate',
				text:      'Fecha de inicio',
				formatter: (cell) => {
					return cell.substr(0, 10);
				}
			},
			{
				dataField: 'finalDate',
				text:      'Fecha de termino',
				formatter: (cell) => {
					return cell.substr(0, 10);
				}
			},
			{
				dataField: 'hour',
				text:      'Hora',
				headerStyle: () => {
					return { width: '5%' };
				},
			},
			{
				dataField: 'image',
				text:      'Imagen',
				formatter: (cell) => {
					return <img
						src   = { cell }
						width = '40%'
						alt   = { 'Sin imagen.' }
					/>
				}
			},
			{
				dataField: 'actions',
				text:      'Acciones',
				headerStyle: () => {
					return { width: '15%' };
				},
				formatter: this.linkActions,
			}
		];

		const total = this.props.total;
		const totalPages = total / 5;


		return (
			<div className="main-content">
				<div className="malls-category-headers">
					GESTIÓN DE NOTIFICACIONES
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<div className="auth-label"></div>
				<div className="auth-label"></div>
				<div className="auth-label"></div>

				<div className="row">
					<div className="col-md-6">
						<Combobox
							className="select-roles"
							data={this.state.types}
							textField='Tipo de notificación'
							value={this.state.comboboxSelected}
							placeholder="Selecciona un tipo de notificación"
							onChange={this.onChangeType}
						/>
					</div>
					<div className="col-md-6 text-left">
						<button
							onClick={this.openModal}
							className="btn btn-success">
							Crear
						</button>
					</div>
				</div>

				<div className="auth-label"></div>
				<div className="user-category-wrapper">
					{
						<div>
							<BootstrapTable
								keyField='_id'
								striped
								hover
								condensed
								data={this.state.notifications}
								headerWrapperClasses="title-table"
								options={customOptions}
								columns={columns}
							/>
						</div>
					}
					{
						<div className="toolbar100 end">
							<button
								className={this.state.skip !== 1 ? "modalButtonPager" : "modalButtonPager disabled"}
								onMouseDown={(e) => {
									e.preventDefault();
									this.setState({
										skip: this.state.skip - 1
									}, () => {
										this.onGetNotifications();
									});
								}}
								disabled={this.state.skip === 1 ? true : false}
							>
								« Anterior
							</button>

							<button
								className={this.state.skip < totalPages ? "modalButtonPager" : "modalButtonPager disabled"}
								onMouseDown={(e) => {
									e.preventDefault();
									this.setState({
										skip: this.state.skip + 1
									}, () => {
										this.onGetNotifications();
									});
								}}
								disabled={this.state.skip < totalPages ? false : true}
							>
								Siguiente »
							</button>
						</div>
					}

				</div>
				{
					<AddNotificationModal
						isVisible={this.state.addModalIsVisible}
						handleSubmit={this.handleSubmit}
						handleCancel={this.handleCancel}
						notificationData={this.state.notificationData}
						type={this.state.modalType}
						handleUpdate={this.handleUpdate}
					/>
				}
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<Dialog
						open={this.state.showDeactivateDialog}
						onClose={this.handleCloseDeactivateDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Desactivar notificación"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								¿Seguro que deseas desactivar la notificación?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDeactivateDialog} color="secondary">
								Cancelar
							</Button>
							<Button onClick={this.onDeactivate} color="primary" autoFocus>
								Desactivar
							</Button>
						</DialogActions>
					</Dialog>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>)

	}
}

const mapStateToProps = state => ({
	notifications: state.notification_reducer.notifications,
	total: state.notification_reducer.total,
	actionType: state.notification_reducer.actionType,
	error: state.notification_reducer.error,
});

export default connect(
	mapStateToProps,
	{
		getNotifications,
		addNotifications,
		updateNotifications,
		deleteNotifications,
		clearErrorBack
	}
)(Notification);